import * as yup from 'yup';
import {
  dateSchema,
  mbiSchema,
  pastOrTodayDateSchema,
  requiredErrorMessage,
} from '@common/schema';
import { MAXIMUM_STRING_LENGTH } from '@common/types/constants';
import { isCashPaymentType } from '../utils';

export const otherInsuranceEntrySchema = yup.object({
  id: yup.string().optional(),

  payment_type: yup
    .string()
    .transform(v => (typeof v === 'string' ? v.trim() : v))
    .required(requiredErrorMessage)
    .min(1, requiredErrorMessage),

  insurance_company: yup.string().when('payment_type', {
    is: isCashPaymentType,
    then: schema => schema.notRequired(),
    otherwise: schema =>
      schema.required(requiredErrorMessage).min(1, requiredErrorMessage),
  }),
  insurance_company_name: yup.string().optional(),
  insurance_id: yup.string().when('payment_type', {
    is: isCashPaymentType,
    then: schema => schema.notRequired(),
    otherwise: schema =>
      schema.required(requiredErrorMessage).min(1, requiredErrorMessage),
  }),

  mbi: mbiSchema.notRequired(),
  group_number: yup.string().notRequired(),
  plan_name: yup.string().notRequired(),

  start_date: dateSchema.required(requiredErrorMessage),
  end_date: dateSchema.notRequired(),

  subscriber: yup
    .object({
      is_patient: yup.string().required(requiredErrorMessage),
      relationship: yup.string().when('is_patient', {
        is: 'false',
        then: schema =>
          schema.required(requiredErrorMessage).min(1, requiredErrorMessage),
        otherwise: schema => schema.notRequired(),
      }),
      subscriber_id: yup.string().notRequired(),
    })
    .when('payment_type', {
      is: isCashPaymentType,
      then: () =>
        yup.object({
          is_patient: yup.string().notRequired(),
          relationship: yup.string().notRequired(),
          subscriber_id: yup.string().notRequired(),
        }) as never,
    }),

  consent: yup.object({
    verbal_consent_date: pastOrTodayDateSchema.notRequired(),
    given_by: yup.string().when('verbal_consent_date', {
      is: (v: unknown) => typeof v === 'string' && v.length > 0,
      then: schema =>
        schema
          .required(requiredErrorMessage)
          .max(
            MAXIMUM_STRING_LENGTH,
            `Maximum of ${MAXIMUM_STRING_LENGTH} characters allowed`,
          ),
      otherwise: schema => schema.notRequired(),
    }),
    witness: yup.string(),
  }),

  comments: yup.string(),
});
